/* eslint no-underscore-dangle: ["error", { "allow": ["_id"]}] */
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import imageBoard from '../../images/common/board.svg';
import imageLocation from '../../images/common/location.svg';
import imageTrash from '../../images/common/trash_can.svg';
import { PAGE_PATH, REMOTE_COMMAND } from '../../lib/constants';
import {
  DeviceListMain,
  DeviceManagerTitle,
  DeviceWrapper,
  DeviceNameWrapper,
  DeviceName,
  LoginAlert,
  DeviceButtons,
  ImageButton,
  LinkButtonImage,
  BlackboardListButton,
  RemoteButtonWrapper,
  RemoteButton,
} from './styles/DeviceListStyles';

const DeviceList = ({
  currentOperator,
  userDevices,
  enableRemoteButton,
  onSendLocation,
  onDelete,
  onRemoteSupportEnd,
  openBlackboardList,
}) => {
  const { operatorId } = currentOperator;
  return (
    <DeviceListMain className="DeviceList">
      <DeviceManagerTitle>
        <FormattedMessage id="timeLine.deviceList.title" />
      </DeviceManagerTitle>
      {userDevices &&
        userDevices.map(device => {
          const {
            deviceId,
            deviceNickname,
            locationInfoOnOff: defaultDevice,
            loginStatus: loggedIn,
            isRemoteSupport,
          } = device;
          const link = `${PAGE_PATH.DS_REMOTE}/pre/${REMOTE_COMMAND.caller}?operatorIds=[${operatorId}]&deviceId=${deviceId}`;
          const diplayLoginAlert = isRemoteSupport && !loggedIn;
          return (
            <DeviceWrapper key={`device${deviceId}`}>
              <DeviceNameWrapper>
                <DeviceName>{deviceNickname}</DeviceName>
                {diplayLoginAlert && (
                  <LoginAlert>
                    <FormattedMessage id="timeLine.deviceList.alert.login" />
                  </LoginAlert>
                )}
              </DeviceNameWrapper>
              <DeviceButtons>
                <ImageButton
                  id={`sendLocationButton${deviceId}`}
                  disabled={defaultDevice}
                  onClick={() => onSendLocation(deviceId)}
                >
                  <LinkButtonImage src={imageLocation} alt="set location" />
                  <FormattedMessage id="timeLine.deviceList.button.setLocationInfo" />
                </ImageButton>
                <ImageButton
                  id={`deleteDeviceButton${deviceId}`}
                  onClick={() => onDelete(deviceId)}
                >
                  <LinkButtonImage src={imageTrash} alt="delte device" />
                  <FormattedMessage id="timeLine.deviceList.button.deleteDevice" />
                </ImageButton>
                <BlackboardListButton isDisplay={enableRemoteButton}>
                  <ImageButton
                    id={`openBlackboardList${deviceId}`}
                    onClick={() => openBlackboardList(deviceId)}
                  >
                    <LinkButtonImage src={imageBoard} alt="show bord list" />
                    <FormattedMessage id="timeLine.deviceList.button.board" />
                  </ImageButton>
                </BlackboardListButton>
                <RemoteButtonWrapper enableRemoteButton={enableRemoteButton}>
                  {(!loggedIn && (
                    <RemoteButton request={false} disabled>
                      <FormattedMessage id="timeLine.deviceList.button.remoteSupport" />
                    </RemoteButton>
                  )) ||
                    (isRemoteSupport && (
                      <Link target="_blank" to={link}>
                        <RemoteButton
                          id={`remoteSupportButton${deviceId}`}
                          role="presentation"
                          className="clickableItem"
                          onClick={e => {
                            e.stopPropagation();
                          }}
                          request={false}
                        >
                          <FormattedMessage id="timeLine.deviceList.button.remoteSupport" />
                        </RemoteButton>
                      </Link>
                    )) || (
                      <RemoteButton
                        id={`remoteSupportEndButton${deviceId}`}
                        role="presentation"
                        onClick={() => onRemoteSupportEnd(deviceId)}
                        isTalking
                      >
                        <FormattedMessage id="timeLine.deviceList.button.remoteSupportEnd" />
                      </RemoteButton>
                    )}
                </RemoteButtonWrapper>
              </DeviceButtons>
            </DeviceWrapper>
          );
        })}
    </DeviceListMain>
  );
};

DeviceList.propTypes = {
  currentOperator: PropTypes.object.isRequired,
  userDevices: PropTypes.array.isRequired,
  enableRemoteButton: PropTypes.bool.isRequired,
  onSendLocation: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onRemoteSupportEnd: PropTypes.func.isRequired,
  openBlackboardList: PropTypes.func.isRequired,
};

export default DeviceList;
